import { render, staticRenderFns } from "./ClubMemberPerformance.vue?vue&type=template&id=5444e87b"
import script from "./ClubMemberPerformance.vue?vue&type=script&lang=js"
export * from "./ClubMemberPerformance.vue?vue&type=script&lang=js"
import style0 from "./ClubMemberPerformance.vue?vue&type=style&index=0&id=5444e87b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports